// REA-CI/screens/PostPropertyScreen.tsx

import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Alert,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { RootStackParamList, StackNavigationProp } from "../navigation/types";

type PostPropertyScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  "PostPropertyScreen"
>;

const PostPropertyScreen = () => {
  const navigation = useNavigation<PostPropertyScreenNavigationProp>();

  const [propertyTitle, setPropertyTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [price, setPrice] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [nearbyLandmarks, setNearbyLandmarks] = useState<string>("");
  const [propertyType, setPropertyType] = useState<string>("");
  const [rooms, setRooms] = useState<string>("");
  const [floors, setFloors] = useState<string>("");
  const [location, setLocation] = useState<string>("");

  const handlePostProperty = () => {
    if (
      !propertyTitle ||
      !description ||
      !price ||
      !city ||
      !nearbyLandmarks ||
      !propertyType ||
      !rooms ||
      !floors ||
      !location
    ) {
      Alert.alert("Error", "Please fill out all fields to post the property.");
      return;
    }

    // Mock function to simulate posting the property (to be replaced with real backend logic)
    Alert.alert("Success", "Your property has been posted successfully.");
    navigation.navigate("SellerHomeScreen");
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Post Your Property</Text>

      <TextInput
        style={styles.input}
        placeholder="Property Title"
        value={propertyTitle}
        onChangeText={setPropertyTitle}
      />
      <TextInput
        style={styles.input}
        placeholder="Description"
        value={description}
        onChangeText={setDescription}
        multiline
      />
      <TextInput
        style={styles.input}
        placeholder="Price (in CFA)"
        value={price}
        onChangeText={setPrice}
        keyboardType="numeric"
      />
      <TextInput
        style={styles.input}
        placeholder="City"
        value={city}
        onChangeText={setCity}
      />
      <TextInput
        style={styles.input}
        placeholder="Nearby Landmarks"
        value={nearbyLandmarks}
        onChangeText={setNearbyLandmarks}
      />
      <TextInput
        style={styles.input}
        placeholder="Property Type (e.g., House, Land, Apartment)"
        value={propertyType}
        onChangeText={setPropertyType}
      />
      <TextInput
        style={styles.input}
        placeholder="Number of Rooms"
        value={rooms}
        onChangeText={setRooms}
        keyboardType="numeric"
      />
      <TextInput
        style={styles.input}
        placeholder="Number of Floors"
        value={floors}
        onChangeText={setFloors}
        keyboardType="numeric"
      />
      <TextInput
        style={styles.input}
        placeholder="Exact Location"
        value={location}
        onChangeText={setLocation}
      />

      <TouchableOpacity style={styles.submitButton} onPress={handlePostProperty}>
        <Text style={styles.buttonText}>Post Property</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "#ffffff",
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 20,
    textAlign: "center",
  },
  input: {
    width: "100%",
    height: 40,
    borderColor: "#ccc",
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 10,
    paddingHorizontal: 10,
  },
  submitButton: {
    backgroundColor: "#28a745",
    paddingVertical: 15,
    paddingHorizontal: 30,
    borderRadius: 5,
    marginTop: 20,
  },
  buttonText: {
    color: "#ffffff",
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
  },
});

export default PostPropertyScreen;
